<template>
  <div class="addAdminStrators">
    <el-form
      :rules="rules"
      ref="form"
      :model="form"
      class="form"
      :label-width="require('@/config/enum').c_ws8"
      :label-suffix="require('@/config/enum').c_colon"
    >
      <el-card>
        <div class="jump-btn">
          <el-button type="primary" @click="jump()">{{$t('lang.btn_backAdminStrators')}}</el-button>
        </div>
        <el-form-item :label="$t('lang.lab_Adminphone')" prop="userName" class="formcontent">
          <el-input
            @input="keyBA"
            maxlength="11"
            v-model="form.userName"
            :disabled="disablephone"
            :placeholder="$t('lang.pla_Adminphone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Adminpassw')" prop="pwd" class="formcontent">
          <el-input
            v-model="form.pwd"
            maxlength="18"
            type="password"
            :placeholder="$t('lang.pla_Adminpassw')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Adminrespassw')" prop="respwd" class="formcontent">
          <el-input
            v-model="form.respwd"
            maxlength="18"
            type="password"
            :placeholder="$t('lang.pla_Adminrespassw')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Adminnickname')" prop="nickName" class="formcontent">
          <el-input
            v-model="form.nickName"
            maxlength="20"
            :placeholder="$t('lang.pla_Adminnickname')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('lang.lab_Distributionauthority')"
          prop="isDispatch"
          class="formcontent"
        >
          <el-radio-group v-model="form.isDispatch">
            <el-radio v-for="item in isDispatchlist" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('lang.lab_Authoritytocomplain')"
          prop="isComplaintAndCommendation"
          class="formcontent"
        >
          <el-radio-group v-model="form.isComplaintAndCommendation">
            <el-radio
              v-for="item in isComplaintAndCommendationlist"
              :label="item.id"
              :key="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_Closetheaccess')" prop="isClose" class="formcontent">
          <el-radio-group v-model="form.isClose">
            <el-radio v-for="item in isCloselist" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_SetUp')" prop="isSetUp" class="formcontent">
          <el-radio-group v-model="form.isSetUp">
            <el-radio v-for="item in isSetUpList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
         <el-form-item :label="$t('lang.lab_isFeeManager')" prop="isFeeManager" class="formcontent">
          <el-radio-group v-model="form.isFeeManager">
            <el-radio v-for="item in isFeeManagerList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
          <el-form-item :label="$t('lang.lab_isExamManager')" prop="isExamManager" class="formcontent">
          <el-radio-group v-model="form.isExamManager">
            <el-radio v-for="item in isExamManagerList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="高管模式" prop="isExecutive" class="formcontent">
          <el-radio-group v-model="form.isExecutive">
            <el-radio v-for="item in isExamManagerList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-card>
      <!-- 人员角色 -->
      <el-card class="role" v-if="rolelist.length>0">
        <el-collapse v-model="activeNames" prop="checkedrole">
          <el-form-item :label="$t('lang.lab_Adminrole')">
            <el-collapse-item :label="$t('lang.lab_Adminrole')" prop="checkedrole">
              <div class="chooseActive">
                <el-checkbox
                  v-model="item.roleischeck"
                  v-for="item in rolelist"
                  :label="item.id"
                  :key="item.id"
                  :title="item.roleName"
                >{{item.roleName}}</el-checkbox>
              </div>
            </el-collapse-item>
          </el-form-item>
        </el-collapse>
      </el-card>
      <!-- 所属小区 -->
      <el-card class="garden">
        <el-collapse v-model="activeNames">
          <el-form-item prop="staffGardenList" :label="$t('lang.lab_Admingarden')">
            <el-collapse-item>
              <el-checkbox-group v-model="form.staffGardenList" class="chooseActive">
                <el-checkbox
                  v-for="item in gardenlist"
                  :label="item.id"
                  :key="item.id"
                  :title="item.name"
                >{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-collapse-item>
          </el-form-item>
        </el-collapse>
      </el-card>
      <el-card class="mune">
        <el-collapse v-model="activeNames">
          <el-form-item
            :label="item.name"
            :prop="item.name"
            v-for="(item, index) in munelist"
            :key="index"
            :name="index"
          >
            <el-collapse-item>
              <div class="chooseActive">
                <el-checkbox
                  v-model="subitem.ischeck"
                  v-for="(subitem, i) in item.children"
                  :key="i"
                  :title="subitem.name"
                >{{subitem.name}}</el-checkbox>
              </div>
            </el-collapse-item>
          </el-form-item>
        </el-collapse>
        <el-button class="btn-first martop" @click="res('form')">{{$t('lang.btn_rest')}}</el-button>
        <el-button
          :disabled="total===0"
          class="detailbtn"
          type="primary"
          @click="onSubmit('form')"
        >{{$t('lang.btn_save')}}</el-button>
      </el-card>
    </el-form>
  </div>
</template>

<script>
/**
 *@ClassName:addAdminStrators
 *@Description:管理员详情
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-02-19
 */
export default {
  data() {
    var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    var isPhone = (rule, value, callback) => {
      if (value === '') {
        callback(
          new Error(
            this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_phoneNum')
          )
        )
      } else if (!phone.test(value)) {
        callback(
          new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
        )
      } else {
        callback()
      }
    }
    var respassword = /^[0-9a-zA-Z]{6,18}$/
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_Adminpassw')))
      } else if (!respassword.test(value)) {
        callback(new Error(this.$i18n.t('lang.lab_inputpassword')))
      } else {
        callback()
      }
    }
    var validateresPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.pla_Adminrespassw')))
      } else if (!respassword.test(value)) {
        callback(new Error(this.$i18n.t('lang.lab_inputpassword')))
      } else if (value != this.form.pwd) {
        callback(new Error(this.$i18n.t('lang.pla_twoAdminrespassw')))
      } else {
        callback()
      }
    }
    return {
      saveData: '', // 存储json字符串
      munesaveData: '', // mune存储json字符串
      rolesaveData: '', // 人员存储json字符串
      isDisabled: 0, // 确定按钮置灰
      isDisabled1: 0, // 确定按钮置灰
      isDisabled3: 0, // 确定按钮置灰
      disablephone: false, // 手机号置灰
      backsuccess: 0, // 查询对象返回
      activeNames: [],
      checkedrole: [], // 选中的人员角色
      rolelist: [], // 所有人员角色
      checkedgarden: [], // 选中的小区
      gardenlist: [], // 所有小区
      munelist: [], // munelist
      id: '', // 区别新增还是修改
      form: {
        nickName: '',
        respwd: '',
        pwd: '',
        userName: '',
        isDispatch: 0,
        isComplaintAndCommendation: 0,
        isClose: 0,
        staffGardenList: [],
        isSetUp: 0,
        isFeeManager: 0,
        isExamManager: 0,
        isExecutive: 0,
        
      }, // 查询对象
      staffGardenList: [], // 小区id绑定
      isDispatchlist: this.$i18n.t('lang.AdminStrators.isDispatchlist'), // 派单权限下拉
      isComplaintAndCommendationlist: this.$i18n.t(
        'lang.AdminStrators.isComplaintAndCommendationlist'
      ), // 表扬/投诉权限权限下拉
      isCloselist: this.$i18n.t('lang.AdminStrators.isCloselist'), // 关闭报事工单权限下拉
      isSetUpList: this.$i18n.t('lang.AdminStrators.isSetUpList'), 
      isFeeManagerList: this.$i18n.t('lang.AdminStrators.isFeeManagerList'), 
      isExamManagerList: this.$i18n.t('lang.AdminStrators.isExamManagerList'), 
      rules: {
        staffGardenList: [
          {
            type: 'array',
            required: true,
            message: this.$i18n.t('lang.check_garden'),
            trigger: 'change'
          }
        ],
        userName: [{ required: true, validator: isPhone, trigger: 'blur' }],
        pwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        respwd: [
          { required: true, validator: validateresPass, trigger: 'blur' }
        ],
        nickName: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Adminnickname'),
            trigger: 'blur'
          }
        ],
        isDispatch: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Distributionauthority'),
            trigger: 'change'
          }
        ],
        isComplaintAndCommendation: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Authoritytocomplain'),
            trigger: 'change'
          }
        ],
        isClose: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Closetheaccess'),
            trigger: 'change'
          }
        ],
        // isSetUp: [
        //   {
        //     required: true,
        //     message: this.$i18n.t('lang.pla_SetUp'),
        //     trigger: 'change'
        //   }
        // ],
        checkedrole: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Adminrole'),
            trigger: 'blur'
          }
        ],
        checkedgarden: [
          {
            required: true,
            message: this.$i18n.t('lang.pla_Admingarden'),
            trigger: 'blur'
          }
        ]
      } // 表单验证
    }
  },
  computed: {
    total: function() {
      return this.isDisabled + this.isDisabled1 + this.isDisabled3
    }
  },
  watch: {
    backsuccess() {
      if (this.backsuccess === 1) {
        this.gardens()
      }
    },
    form: {
      handler(newVal, oldVal) {
        console.log(newVal.staffGardenList)
        for (var j = 0; j < newVal.staffGardenList.length - 1; j++) {
          for (var i = 0; i < newVal.staffGardenList.length - 1; i++) {
            if (newVal.staffGardenList[i] > newVal.staffGardenList[i + 1]) {
              var temp = newVal.staffGardenList[i]
              newVal.staffGardenList[i] = newVal.staffGardenList[i + 1]
              newVal.staffGardenList[i + 1] = temp
            }
          }
        }
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = 0
        } else {
          this.isDisabled = 1
        }
      },
      deep: true,
      immediate: true
    },
    munelist: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.munesaveData) {
          this.isDisabled1 = 0
        } else {
          this.isDisabled1 = 1
        }
      },
      deep: true,
      immediate: true
    },
    rolelist: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.rolesaveData) {
          this.isDisabled3 = 0
        } else {
          this.isDisabled3 = 1
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
      // 点击修改按钮查询详情对象
      this.rules.pwd[0].required = false
      this.rules.respwd[0].required = false
      if (window.localStorage.getItem('glyform')) {
      this.gardens()
      this.form = JSON.parse(window.localStorage.getItem('glyform'))
      if (window.localStorage.getItem('glysaveData')) {
      this.saveData = JSON.parse(window.localStorage.getItem('glysaveData'))
      }
      if (window.localStorage.getItem('glyrolelist')) {
      this.rolelist = JSON.parse(window.localStorage.getItem('glyrolelist'))
      }
      if (window.localStorage.getItem('glymunelist')) {
      this.munelist = JSON.parse(window.localStorage.getItem('glymunelist'))
      }
      if (window.localStorage.getItem('glystaffGardenList')) {
      this.staffGardenList = JSON.parse(window.localStorage.getItem('glystaffGardenList'))
      }
    } else {
       if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.admins()
      this.getRoleListAndAdminInfoByStaffId()
      this.getMunuListAndAdminInfoByStaffId()
    } else {
      // 点击新增按钮
      this.backsuccess = 1
      this.getRoleListAndAdminInfoByStaffId()
      this.getMunuListAndAdminInfoByStaffId()
    }
    }
  },
  destroyed() {
    window.localStorage.setItem('glyform', JSON.stringify(this.form))
    window.localStorage.setItem('glystaffGardenList', JSON.stringify(this.staffGardenList))
    window.localStorage.setItem('glysaveData', JSON.stringify(this.saveData))
    window.localStorage.setItem('glyrolelist', JSON.stringify(this.rolelist))
    window.localStorage.setItem('glymunelist', JSON.stringify(this.munelist))
  },
  methods: {
    // 用户名只能输入数字
    keyBA() {
      // 仅保留数字和"."
      this.form.userName = this.form.userName.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      if (this.form.userName.indexOf('.') < 0 && this.form.userName != '') {
        this.form.userName = parseFloat(this.form.userName)
      }
    },
    // 数组排序用
    sequence(a, b) {
      return a - b
    },
    // 通过id查看对象详情
    admins() {
      let loading = this.$loading()
      this.$get(`/admins/` + this.id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
              this.form = res
            for (var i = 0; i < this.form.staffGardenList.length; i++) {
              this.staffGardenList.push(this.form.staffGardenList[i].gardenId)
            }
            this.form.staffGardenList = this.staffGardenList.sort(
              this.sequence
            )
            this.saveData = JSON.stringify(this.form)
            this.backsuccess = 1
            this.disablephone = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // MUNElist
    getMunuListAndAdminInfoByStaffId() {
      let loading = this.$loading()
      this.$get(`/getMunuListAndAdminInfoByStaffId?staffId=${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.munelist = res.result
            for (var j = 0; j < this.munelist.length; j++) {
              for (var K = 0; K < this.munelist[j].children.length; K++) {
                if (this.munelist[j].children[K].checkFlag === 1) {
                  this.$set(this.munelist[j].children[K], 'ischeck', true) // 这里，给对象添加属性，用$set方法
                } else {
                  this.$set(this.munelist[j].children[K], 'ischeck', false) // 这里，给对象添加属性，用$set方法
                }
              }
            }
            this.munesaveData = JSON.stringify(this.munelist)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.gardenlist = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 人员角色list
    getRoleListAndAdminInfoByStaffId() {
      let loading = this.$loading()
      this.$get(`/getRoleListAndAdminInfoByStaffId?staffId=${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.rolelist = res.result
            this.rolelist.map(item => {
              if (item.checkFlag === 1) {
                this.$set(item, 'roleischeck', true) // 这里，给对象添加属性，用$set方法。
              } else {
                this.$set(item, 'roleischeck', false) // 这里，给对象添加属性，用$set方法。
              }
            })
            this.rolesaveData = JSON.stringify(this.rolelist)
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回list页面
    jump() {
      this.$router.push({ name: 'administratorsList' })
    },
    // 清空
    res(formName) {
      // 新增清空手机号，修改手机号不可清空
      if (this.disablephone === false) {
        this.form.userName = ''
      }
      if (this.form.pwd) {
        this.form.pwd = ''
      }
      if (this.form.respwd) {
        this.form.respwd = ''
      }
      this.form.nickName = ''
      this.form.isDispatch = 0
      this.form.isComplaintAndCommendation = 0
      this.form.isClose = 0
      for (var i = 0; i < this.rolelist.length; i++) {
        this.$set(this.rolelist[i], 'roleischeck', false)
      }
      this.form.staffGardenList = []
      for (var j = 0; j < this.munelist.length; j++) {
        for (var K = 0; K < this.munelist[j].children.length; K++) {
          this.$set(this.munelist[j].children[K], 'ischeck', false)
        }
      }
       setTimeout(() => {
        this.$refs[formName].clearValidate()
      }, 0)
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
            let params = {
              gardenIds: this.form.staffGardenList.toString(),
              userName: this.form.userName,
              pwd: this.form.pwd,
              nickName: this.form.nickName,
              isDispatch: this.form.isDispatch,
              isComplaintAndCommendation: this.form.isComplaintAndCommendation,
              isClose: this.form.isClose,
              isSetUp: this.form.isSetUp,
              isFeeManager: this.form.isFeeManager,
              isExamManager: this.form.isExamManager,
              isExecutive: this.form.isExecutive
            }
            // roleStaff后台格式 Map<String, Object> roleStaff;
            let roleid = {}
            for (var i = 0; i < this.rolelist.length; i++) {
              if (this.rolelist[i].roleischeck === true) {
                roleid[i] = this.rolelist[i].id
              }
            }
            if (roleid) {
              params.roleStaff = roleid
            }
            // let childrenid = []
            for (var j = 0; j < this.munelist.length; j++) {
              let childrenid = []
              for (var K = 0; K < this.munelist[j].children.length; K++) {
                if (this.munelist[j].children[K].ischeck === true) {
                  childrenid.push(this.munelist[j].children[K].id)
                }
              }
              // munuStaff后台格式：List<List<Integer>> munuStaff
              if (childrenid.length > 0) {
                if (!params.munuStaff) {
                  params.munuStaff = []
                }
                params.munuStaff.push(childrenid)
              }
            }

            let loading = this.$loading()
            this.$postJson(`/AOEAdmin/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  // 杜，keepalive
                  var index = this.$keepAlive.indexOf('/manage/main.adminList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'administratorsList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            let params = {
              id: this.id,
              gardenIds: this.form.staffGardenList.toString(),
              userName: this.form.userName,
              pwd: this.form.pwd,
              nickName: this.form.nickName,
              isDispatch: this.form.isDispatch,
              isComplaintAndCommendation: this.form.isComplaintAndCommendation,
              isClose: this.form.isClose,
              isSetUp: this.form.isSetUp,
              isFeeManager: this.form.isFeeManager,
              isExamManager: this.form.isExamManager,
              isExecutive: this.form.isExecutive
            }
            console.log(params)
            let roleid = {}
            for (var l = 0; l < this.rolelist.length; l++) {
              if (this.rolelist[l].roleischeck === true) {
                roleid[l] = this.rolelist[l].id
              }
            }
            if (roleid) {
              params.roleStaff = roleid
            }
            for (var m = 0; m < this.munelist.length; m++) {
              let childrenid = []
              for (var n = 0; n < this.munelist[m].children.length; n++) {
                if (this.munelist[m].children[n].ischeck === true) {
                  childrenid.push(this.munelist[m].children[n].id)
                }
              }
              // munuStaff后台格式：List<List<Integer>> munuStaff
              if (childrenid.length > 0) {
                if (!params.munuStaff) {
                  params.munuStaff = []
                }
                params.munuStaff.push(childrenid)
              }
            }

            let loading = this.$loading()
            this.$postJson(`/AOEAdmin/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(
                    this.$i18n.t('lang.lab_modify_success')
                  )
                  // 杜，keepalive
                  var index = this.$keepAlive.indexOf('/manage/main.adminList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({ name: 'administratorsList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.addAdminStrators .formcontent {
  width: 60vw !important;
}
.addAdminStrators .el-card {
  min-height: 0px;
  margin-top: 10px;
}
.addAdminStrators .el-collapse-item__header {
  padding-left: 69px;
}
.addAdminStrators .martop {
  margin-top: 20px;
  margin-left: 20px;
}
.addAdminStrators .garden .el-collapse-item__header {
  border-bottom: 0px;
}
.addAdminStrators .role .el-collapse-item__header {
  border-bottom: 0px;
}
.addAdminStrators .el-collapse {
  border-top: 0px;
  border-bottom: 0px;
}
.addAdminStrators .el-collapse-item__wrap {
  border-bottom: 0px;
}
.addAdminStrators .mune .el-form-item {
  margin-bottom: 1px;
}
// 解决多选框长度过长显示异常问题
.addAdminStrators {
  .chooseActive {
    label {
      .el-checkbox__label {
        max-width: 155px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle; // 纵向居中
      }
    }
  }
}
.addAdminStrators .el-checkbox,.el-checkbox-button__inner,.el-radio{
  width:160px;
}
</style>